import { HttpEventType, HttpResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UploadsService } from 'src/app/services/uploads/uploads.service';
import { AlertService } from '../../services/alert.service';

@Component({
  selector: 'app-upload-files',
  templateUrl: './upload-files.component.html',
  styleUrls: ['./upload-files.component.scss'],
})
export class UploadFilesComponent implements OnInit {
  @Output() emitter = new EventEmitter<any[]>();

  @Input() singleFile;
  @Input() showButton = true;

  selectedFiles: FileList;
  progressInfos = [];
  message = '';
  uploading = false;

  uploadedFileIds = [];
  constructor(
    private uploadsService: UploadsService,
    private alertService: AlertService
  ) {}

  ngOnInit() {}

  selectFiles(event) {
    this.progressInfos = [];
    this.selectedFiles = event.target.files;
    if (!this.showButton) {
      for (let index = 0; index < this.selectedFiles.length; index++) {
        if (this.selectedFiles[index].size > 50940000) {
          this.alertService.errorAlert(
            'El archivo ingresado es muy pesado. El límite son 50MB'
          );
          return;
        }
      }
      this.emitter.emit(this.selectedFiles as any);
    }
  }

  uploadFiles() {
    for (let i = 0; i < this.selectedFiles.length; i++) {
      this.upload(i, this.selectedFiles[i]);
    }
  }

  upload(idx, file) {
    if (file.size > 50940000) {
      this.alertService.errorAlert(
        'El archivo ingresado es muy pesado. El límite son 50MB'
      );
      return;
    }

    this.message = '';
    this.uploading = true;

    this.progressInfos[idx] = {
      value: 0,
      fileName: file.name,
      uploaded: false,
    };

    this.uploadsService.upload(file).subscribe(
      (event) => {
        if (event.type === HttpEventType.UploadProgress) {
          this.progressInfos[idx].value = event.loaded / event.total;
        } else if (event instanceof HttpResponse) {
          this.progressInfos[idx].uploaded = true;
          this.uploadedFileIds.push(event.body.id);
          this.emitFilesIds();
        }
      },
      (err) => {
        this.progressInfos[idx].value = 0;
        console.log(err, 'error en uploadsService.upload');
        this.message = `No se pudo cargar el archivo: ${file.name}. \nRazón: ${
          err?.error?.message === 'The given data was invalid'
            ? 'El formato de archivo es desconocido para nuestra plataforma'
            : err?.error?.message
        }`;
      }
    );
  }

  emitFilesIds() {
    this.emitter.emit(this.uploadedFileIds);
  }
}
